import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const channelAnalyticsSLice = createAppSlice({
  name: 'channelAnalytics',
  initialState,
  reducers,
});

export const { updateFetchedChannelStats, fetchMoreChannelProjects } = channelAnalyticsSLice.actions;

export default channelAnalyticsSLice.reducer;
